<template>
  <div
    v-if="
      (action === 'Cancel' && reserva.estado !== ESTADOS_RESERVA.CANCELADA) ||
      (action === 'Recover' && reserva.estado === ESTADOS_RESERVA.CANCELADA) ||
      action === 'Pay'
    "
    class="card_pago text-primary w-100">
    <div class="pt-2 px-3">
      <div class="pb-2">
        <label
          class="w-100 d-flex align-items-center justify-content-between text-end"
          :class="{ 'fw-bold': reserva.nombreUsuario }">
          <span class="text-primary">{{ reserva.nombreUsuario }}</span>
        </label>
      </div>
      <hr class="line-divider mt-0" />
    </div>
    <div class="col-12">
      <div class="p-3 pt-0 m-0 fw-normal text-primary text-detalle">
        <template v-if="action === 'Cancel' && reserva.estado !== ESTADOS_RESERVA.CANCELADA">
          <template v-if="reserva.totalPagado != reserva.precioTotal">
            <div class="row w-100">
              <div class="col">
                {{ $t('reserva.totalPendiente') }}
              </div>
              <div class="col-auto text-secondary fw-bold">
                {{ reserva.totalPagado }} {{ agenciaStore.getCurrency }}
              </div>
            </div>
            <div class="row w-100">
              <div class="col">
                <i18n-t keypath="reserva.gastoCancelacion" tag="div">
                  <template #fechaHoy>
                    <span>{{ todayDate }}</span>
                  </template>
                </i18n-t>
              </div>
              <div class="col-auto text-secondary fw-bold">{{ gastoCancelacion }} {{ agenciaStore.getCurrency }}</div>
            </div>

            <div class="row w-100 pt-2">
              <div class="col">
                {{ $t('reserva.saldoPendiente') }}
              </div>
              <div class="col-auto text-secondary fw-bold">
                {{ calculateTotal(reserva.totalPagado, gastoCancelacion) }} {{ agenciaStore.getCurrency }}
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row w-100">
              <div class="col">
                {{ $t('reserva.pagoTotal') }}
              </div>
              <div class="col-auto text-secondary fw-bold">
                {{ roundNumbers(reserva.totalPagado, 2) }} {{ agenciaStore.getCurrency }}
              </div>
            </div>
            <div class="row w-100">
              <div class="col">
                <i18n-t keypath="reserva.gastoCancelacion" tag="div">
                  <template #fechaHoy>
                    <span>{{ todayDate }}</span>
                  </template>
                </i18n-t>
              </div>
              <div class="col-auto text-secondary fw-bold">{{ gastoCancelacion }} {{ agenciaStore.getCurrency }}</div>
            </div>

            <div class="row w-100 pt-2">
              <div class="col">
                {{ $t('reserva.totalDevolver') }}
              </div>
              <div class="col-auto text-secondary fw-bold">
                {{ roundNumbers(reserva.totalPagado - gastoCancelacion, 2) }} {{ agenciaStore.getCurrency }}
              </div>
            </div>
          </template>
        </template>
        <template
          v-else-if="(action === 'Recover' && reserva.estado === ESTADOS_RESERVA.CANCELADA) || action === 'Pay'">
          <div class="row w-100 pt-2">
            <div class="col fw-bold pb-2">
              {{ $t('reserva.paqueteBasico') }}
            </div>
            <div class="col-auto text-secondary fw-bold">
              {{ roundNumbers(reserva.precioBasico, 2).toFixed(2) }} {{ agenciaStore.getCurrency }}
            </div>
          </div>

          <div v-for="incluye in grupo.viaje.incluyes" :key="incluye.id" class="row w-100">
            <div class="col">
              {{ incluye.nombre }}
            </div>
          </div>
          <div
            v-for="servicio in reserva.serviciosWithCantidad.map(swc => swc.servicio)"
            :key="servicio.id"
            class="row w-100">
            <template v-if="!servicio.nulo">
              <div class="col">
                {{ servicio.nombre }}({{ servicio.numDias }}
                <span v-if="servicio.numDias === 1"> {{ $t('general.dia') }}</span>
                <span v-else> {{ $t('general.dias') }}</span
                >)
              </div>

              <div v-if="servicio.precio !== 0" class="col-auto text-secondary fw-bold">
                <span>{{ formatPrice(servicio.precio) }} {{ agenciaStore.getCurrency }}</span>
              </div>
            </template>
          </div>

          <template v-if="hasReservaSumplementos">
            <div class="col-12 fw-bold text-primary py-2">
              {{ $t('reserva.suplementosGastos') }}
            </div>
            <div v-for="gasto in reserva.gastos" :key="gasto.id" class="row w-100">
              <div class="col">
                {{ gasto.concepto }}
              </div>

              <div class="col-auto text-secondary fw-bold">
                <template v-if="gasto.importe !== 0">
                  <span>{{ formatPrice(gasto.importe) }} {{ agenciaStore.getCurrency }}</span>
                </template>
              </div>
            </div>
            <div v-for="tasa in reserva.tasasExternas" :key="tasa.id" class="row w-100">
              <div class="col">
                {{ $t(`reserva.tasas.externas.${tasa.codigo}`) }}
              </div>

              <div class="col-auto text-secondary fw-bold">
                <template v-if="tasa.importe !== 0">
                  <span>{{ formatPrice(tasa.importe) }} {{ agenciaStore.getCurrency }}</span>
                </template>
              </div>
            </div>
            <template v-if="grupo.viaje.repercutirFee">
              <div v-for="tasa in reserva.tasasInternas" :key="tasa.id" class="row w-100">
                <div class="col">
                  {{ $t(`reserva.${tasa.concepto}`) }}
                </div>

                <div class="col-auto text-secondary fw-bold">
                  <template v-if="tasa.importe !== 0">
                    <span>{{ formatPrice(tasa.importe) }} {{ agenciaStore.getCurrency }}</span>
                  </template>
                </div>
              </div>
            </template>
          </template>

          <template v-if="reserva.complementos && reserva.complementos.length > 0">
            <div class="col-12 fw-bold text-primary py-2">
              {{ $t('reserva.complementos') }}
            </div>
            <div v-for="complemento in reserva.complementos" :key="complemento.id" class="row w-100">
              <div class="col">
                {{ $t(`reserva.gastos.${complemento.concepto}`) }}
              </div>
              <div class="col-auto text-secondary fw-bold">
                <template v-if="complemento.importe !== 0">
                  <span>{{ formatPrice(complemento.importe) }} {{ agenciaStore.getCurrency }}</span>
                </template>
              </div>
            </div>
          </template>
          <template v-if="reserva.pagos.length > 0 && !fromMisReservas">
            <div class="col-12 fw-bold text-primary py-2">{{ $t('general.pagos') }}</div>
            <div v-for="p in reserva.pagos" :key="p" class="row w-100">
              <div class="col">{{ p.concepto }}</div>

              <div class="col-auto text-secondary fw-bold">
                <template v-if="p.cantidad !== 0">
                  <span>- {{ formatPrice(p.cantidad) }} {{ agenciaStore.getCurrency }}</span>
                </template>
              </div>
            </div>
          </template>
          <hr class="line-divider pt-2" />
          <div v-if="!fromMisReservas" class="row w-100 text-description">
            <div class="col-6">{{ $t('subtitulo.total') }}</div>
            <div class="col text-end">
              {{ formatPrice(reserva.precioTotal - reserva.totalPagado) }} {{ agenciaStore.getCurrency }}
            </div>
          </div>
          <div v-else class="row w-100 text-description">
            <div class="col-6 fw-bold">{{ $t('subtitulo.total') }}</div>
            <div class="col text-end fw-bold text-secondary">
              {{ formatPrice(reserva.precioTotal) }} {{ agenciaStore.getCurrency }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, ref, watch } from 'vue';
  import { normalizeDate } from '@/helpers/dateUtiles';
  import { roundNumbers, formatPrice } from '@/helpers/numberUtils';
  import { ESTADOS_RESERVA } from '@/constants/reservaConstants';
  import { agenciaStoreModule } from '@/store_pinia/agencia';

  const props = defineProps({
    reserva: {
      type: Object,
      default: () => ({}),
    },
    grupo: {
      type: Object,
      default: () => ({}),
    },
    reset: {
      type: Boolean,
      default: false,
    },

    action: {
      type: String,
      default: '',
    },

    fromMisReservas: {
      type: Boolean,
      default: false,
    },
  });

  const agenciaStore = agenciaStoreModule();
  const cardOpen = ref(false);
  const addToPay = ref(true);

  const formatDate = date => {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
  };

  const todayDate = computed(() => formatDate(new Date()));
  const hasReservaSumplementos = computed(() =>
    (props.reserva.tasasInternas.length > 0 && props.grupo.viaje.repercutirFee) ||
    props.reserva.tasasExternas.length > 0 ||
    props.reserva.gastos.length > 0
  );

  const gastoCancelacion = computed(() => {
    if (!props.grupo.politicaCancelacion) return 0;
    const hoy = normalizeDate(new Date());

    const tramos = props.grupo.politicaCancelacion.tramos || [];
    if (tramos.length === 0) return 0;

    let ultimoTramoFechaFin = normalizeDate(tramos[tramos.length - 1].fechaFin);

    for (let tramo of tramos) {
      const inicio = normalizeDate(tramo.fechaInicio);
      const fin = normalizeDate(tramo.fechaFin);

      if (hoy >= inicio && hoy <= fin) {
        return tramo.porcentaje > 0
          ? roundNumbers(Number((props.reserva.value.precioTotal * tramo.porcentaje) / 100), 2)
          : 0;
      }
    }
    if (hoy > ultimoTramoFechaFin) {
      return roundNumbers(Number(props.reserva.value.precioTotal), 2);
    }

    return 0;
  });

  function calculateTotal(totalPagado, gastoCancelacion) {
    if (totalPagado < gastoCancelacion) {
      return roundNumbers(gastoCancelacion - totalPagado, 2);
    } else {
      return roundNumbers(totalPagado - gastoCancelacion, 2);
    }
  }

  watch(props.reset, () => {
    cardOpen.value = false;
    addToPay.value = false;
  });
</script>

<style lang="css" scoped>
  .card_pago {
    border-radius: var(--bs-border-radius-xl);
    border: 1px solid rgba(33, 36, 68, 0.25);
  }

  .text-detalle {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
</style>
